import { useEffect, useState } from "react";
import LeftSidePopupLayout from "./modal-layout";
import XCloseIcon from "../icons/x-close";
import Style from "./style.module.css";
import { useApiCall } from "../custom-hooks/api-call";
import { useFormik } from "formik";
import * as yup from "yup";
import moment from "moment";
import { File, UploadCloud } from "lucide-react";
import InnerLoader from "../ui/loader/inner-loader";
import { Link } from "react-router";
import Select from "react-select";

const VanLicenseModal = ({
  onSubmit = () => {},
  onClose = () => {},
  onError = () => {},
  licenseData,
  van = []
}) => {
  const apiCall = useApiCall();
  const [imageError, setImageError] = useState(false);

  useEffect(() => {
    if (licenseData?.id) {
      formik.setFieldValue("van_id", licenseData?.van_id || "");
      formik.setFieldValue("issue_date", licenseData?.issue_date || "");
      formik.setFieldValue("expiry_date", licenseData?.expiry_date || "");
      formik.setFieldValue(
        "license_number",
        licenseData?.license_number?.replaceAll(",", "") || ""
      );
      formik.setFieldValue(
        "license_file_url",
        licenseData?.license_file_url || ""
      );
      formik.setFieldValue("license_type", licenseData?.license_type || "");
    }
  }, []);

  const validationSchema = yup.object({
    van_id: yup
      .string("This Field is Required")
      .required("This Field is Required"),
    license_number: yup
      .string("This Field is Required")
      .required("This Field is Required"),
    license_file_url: yup
      .string("This Field is Required")
      .required("This Field is Required"),
    license_type: yup
      .string("This Field is Required")
      .required("This Field is Required"),
    issue_date: yup
      .string("This Field is Required")
      .required("This Field is Required"),
    expiry_date: yup
      .string("This Field is Required")
      .required("This Field is Required"),
  });

  const formik = useFormik({
    initialValues: {
      van_id: "",
      license_number: "",
      license_file_url: "",
      license_type: "",
      issue_date: "",
      expiry_date: "",
      licenseImageLoader: false,
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      console.log("values", values);

      let extraData = {};

      if (licenseData.id) {
        extraData = {
          id: licenseData.id,
        };
      }

      let data = {
        ...extraData,
        van_id: values.van_id,
        license_number: values.license_number,
        license_file_url: values.license_file_url,
        license_type: values.license_type,
        issue_date: moment(values.issue_date).format("YYYY-MM-DD"),
        expiry_date: moment(values.expiry_date).format("YYYY-MM-DD"),
      };

      try {
        let apiRes = await apiCall({
          method: "post",
          url: "add-update-van-driver-license",
          data: data,
        });
        formik.resetForm();
        onSubmit(apiRes?.message || `Request Submitted`);
      } catch (error) {
        console.log("Error", error);
        onError(
          error?.response.data?.respMsg ||
            error?.response.data?.responseMessage ||
            error?.response.data?.message ||
            "Some Thing Went Wrong"
        );
      }
    },
  });

  const handleFileUpload = async (file, type) => {
    let apiData = new FormData();
    apiData.append("file", file);
    if (type == "license_file_url") {
      setImageError(false);
      formik.setFieldValue("license_file_url", "");
      formik.setFieldValue("licenseImageLoader", true);

      try {
        let apiRes = await apiCall({
          method: "post",
          url: "upload",
          data: apiData,
        });

        if (type == "license_file_url") {
          formik.setFieldValue("license_file_url", apiRes?.path?.filepath);
          formik.setFieldValue("licenseImageLoader", false);
        }
        console.log("apiRes", apiRes?.path?.filepath, type);
      } catch (error) {
        console.log("Error", error);
      }
    }
  };

  return (
    <form onSubmit={formik.handleSubmit}>
      <LeftSidePopupLayout
        popupStatus={true}
        className={`${Style.addMeModal} ${Style.leaveModal} !gap-0`}
      >
        <div className={`${Style["modal_header"]} ${Style.addMeModal_head}`}>
          <h4>{licenseData?.id ? "Update" : "Add"} Van License</h4>
          <div
            onClick={onClose}
            className={`${Style["close_btn"]} cursor-pointer`}
          >
            <XCloseIcon />
          </div>
        </div>

        <div className={`${Style.addMeModal_body}`}>
          <div className={`${Style.dcmb__card}`}>
            <div className={`${Style.dcmb__cardBody}`}>
              <div className={`${Style.dcmb__cardBody_formArea} pt-3`}>

                {/* Employee Dropdown */}
                <div className={Style["dcmb__cardBody_formArea_feild"]}>
                  <label htmlFor="">Van</label>
                  <Select
                    placeholder={` -- Select Van -- `}
                    value={
                      formik.values.van_id
                        ? van
                            ?.map((ele) => ({
                              label: ele?.name,
                              value: ele?.id,
                            }))
                            ?.find(
                              (opt) => opt.value === formik.values.van_id
                            )
                        : null
                    }
                    onChange={(selected) => {
                      formik.setFieldValue("van_id", selected?.value);
                    }}
                    options={van?.map(
                      (ele) => ({ label: ele?.name, value: ele?.id })
                    )}
                    className="w-full h-12"
                    components={{
                      IndicatorSeparator: () => null, // 🚀 removes separator
                    }}
                    styles={{
                      control: (base, state) => ({
                        ...base,
                        height: "48px",
                        minHeight: "48px",
                        borderRadius: "0.375rem", // rounded-md
                        borderColor: "#d1d5db", // blue-500 or gray-300
                        boxShadow: "none", // focus:ring-2 ring-blue-500
                        "&:hover": {
                          borderColor: "#9ca3af", // gray-400
                        },
                        fontSize: "14px", // text-xs
                        paddingLeft: "0.5rem", // px-2
                        paddingRight: "0.5rem",
                      }),
                      valueContainer: (base) => ({
                        ...base,
                        height: "48px",
                        padding: "0 0.25rem",
                      }),
                      dropdownIndicator: (base) => ({
                        ...base,
                        padding: "0px 0px 20px",
                        width: "14px",
                        height: "14px",
                      }),
                      input: (base) => ({
                        ...base,
                        margin: 0,
                        padding: 0,
                        fontSize: "14px",
                      }),
                      singleValue: (base) => ({
                        ...base,
                        fontSize: "14px",
                        color: "#374151", // text-gray-700
                      }),
                      placeholder: (base) => ({
                        ...base,
                        fontSize: "14px",
                        color: "#9ca3af", // text-gray-400
                      }),
                      menu: (base) => ({
                        ...base,
                        marginTop: "2px",
                        borderRadius: "0.375rem",
                        border: "1px solid #e5e7eb", // gray-200
                        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                        zIndex: 50,
                      }),
                      indicatorContainer: (base) => ({
                        ...base,
                        padding: "0px",
                      }),
                      option: (base, state) => ({
                        ...base,
                        fontSize: "14px",
                        padding: "0.5rem 0.75rem",
                        cursor: "pointer",
                        backgroundColor: state.isSelected
                          ? "#3b82f6"
                          : state.isFocused
                          ? "#f3f4f6"
                          : "white",
                        color: state.isSelected ? "white" : "#374151", // text-gray-700
                      }),
                    }}
                  />
                  {/* { } */}
                  {formik.touched.van_id &&
                  Boolean(formik.errors.van_id) ? (
                    <span style={{ color: "red" }} className="ps-1">
                      {formik.touched.van_id && formik.errors.van_id}
                    </span>
                  ) : null}
                </div>

                {/* License Number */}

                <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                  <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                    <label htmlFor="">License number</label>
                    <input
                      type="text"
                      name="license_number"
                      min={1}
                      value={formik.values.license_number}
                      onChange={formik.handleChange}
                      placeholder="License Number"
                    />
                    {formik.touched.license_number &&
                    Boolean(formik.errors.license_number) ? (
                      <span style={{ color: "red" }} className="ps-1">
                        {formik.touched.license_number &&
                          formik.errors.license_number}
                      </span>
                    ) : null}
                  </div>
                </div>

                {/* License  Type */}
                <div className={Style["dcmb__cardBody_formArea_feild"]}>
                  <label htmlFor="">License Type</label>
                  <select
                    name="license_type"
                    value={formik.values.license_type}
                    onChange={formik.handleChange}
                  >
                    <option value="" disabled>
                      -- Select Type --
                    </option>
                    <option value="learning">Learning</option>
                    <option value="normal">Normal</option>
                  </select>
                  {/* { } */}
                  {formik.touched.license_type &&
                  Boolean(formik.errors.license_type) ? (
                    <span style={{ color: "red" }} className="ps-1">
                      {formik.touched.license_type &&
                        formik.errors.license_type}
                    </span>
                  ) : null}
                </div>

                {/*  license issue date */}

                <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                  <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                    <label htmlFor="">Issue Date</label>
                    <input
                      type="date"
                      name="issue_date"
                      min={1}
                      value={formik.values.issue_date}
                      onChange={formik.handleChange}
                      placeholder="Issue Date"
                    />
                    {formik.touched.issue_date &&
                    Boolean(formik.errors.issue_date) ? (
                      <span style={{ color: "red" }} className="ps-1">
                        {formik.touched.issue_date && formik.errors.issue_date}
                      </span>
                    ) : null}
                  </div>
                </div>

                {/* License expiry date */}
                <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                  <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                    <label htmlFor="">Expiry Date</label>
                    <input
                      type="date"
                      name="expiry_date"
                      min={1}
                      value={formik.values.expiry_date}
                      onChange={formik.handleChange}
                      placeholder="Expiry Date"
                    />
                    {formik.touched.expiry_date &&
                    Boolean(formik.errors.expiry_date) ? (
                      <span style={{ color: "red" }} className="ps-1">
                        {formik.touched.expiry_date &&
                          formik.errors.expiry_date}
                      </span>
                    ) : null}
                  </div>
                </div>

                {/* License Image */}

                <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                  <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                    <label htmlFor="">License Image</label>
                    <label
                      onDrop={(e) => {
                        e.preventDefault();
                        handleFileUpload(
                          e.dataTransfer.files?.[0],
                          "license_file_url"
                        );
                      }}
                      onDragOver={(e) => e.preventDefault()}
                      className="flex flex-col !items-center justify-center w-full h-40 border-2 border-dashed border-gray-300 rounded-2xl cursor-pointer bg-gray-50 hover:bg-gray-100 transition"
                    >
                      {formik?.values?.licenseImageLoader ? (
                        <InnerLoader
                          wrapperClass="!w-10 !h-10"
                          textStatus={false}
                        />
                      ) : (
                        <UploadCloud className="w-10 h-10 text-gray-500 mb-2" />
                      )}
                      <p className="text-gray-600 font-medium">
                        Drag & Drop files here
                      </p>
                      <p className="text-sm text-gray-400">
                        or click to browse
                      </p>
                      <input
                        type="file"
                        onChange={(e) => {
                          handleFileUpload(
                            e.target.files[0],
                            "license_file_url"
                          );
                        }}
                        className="hidden"
                      />
                    </label>
                    {formik.values?.license_file_url ? (
                      <div className="">
                        <Link
                          to={formik.values?.license_file_url}
                          target="_blank"
                          className="inline-block"
                        >
                          {imageError ? (
                            <div className="h-20 w-20 shrink-0 rounded-md bg-gradient-to-br from-indigo-500/20 to-emerald-500/20 grid place-items-center text-xs font-medium">
                              <File />
                            </div>
                          ) : (
                            <img
                              src={formik.values?.license_file_url}
                              alt={formik?.values?.license_number}
                              className="h-20 w-20 rounded-md"
                              onError={(e) => {
                                e.target.classList.add("hidden");
                                setImageError(true);
                              }}
                            />
                          )}
                        </Link>
                      </div>
                    ) : null}
                    {formik.touched.license_file_url &&
                    Boolean(formik.errors.license_file_url) ? (
                      <span style={{ color: "red" }} className="ps-1">
                        {formik.touched.license_file_url &&
                          formik.errors.license_file_url}
                      </span>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={`${Style.dcmb__cardFoot}`}>
          <button
            type="reset"
            className={`${Style.dcmb__cancel}`}
            onClick={onClose}
          >
            Discard
          </button>
          <button type="submit" className={`${Style.dcmb__submit}`}>
            Apply
          </button>
        </div>
      </LeftSidePopupLayout>
    </form>
  );
};

export default VanLicenseModal;
